import { pathOr } from 'ramda';
import type { ProductBlockSet } from '../models.generated';
import { useProductBlockSetQuery } from '../queries/contentTypes/productBlockSet.generated';
import type { ProductBlockData } from './useProductBlockData';
import { transformProductBlockData } from './useProductBlockData';

export type ProductBlockSetData = ProductBlockData[];

export const transformProductBlockSetData = (response: object): ProductBlockData[] => {
  const rawProductBlocks = pathOr(
    [],
    ['data', 'productBlockSet', 'productBlocksCollection', 'items'],
    response,
  );

  const productBlocksCollectionWithFallbacks: ProductBlockData[] = rawProductBlocks
    .filter((el: ProductBlockData) => Boolean(el))
    .map((rawProductBlock: ProductBlockData) =>
      transformProductBlockData({ data: { productBlock: rawProductBlock } }),
    );

  return productBlocksCollectionWithFallbacks;
};

const useProductBlockSetData = (id: ProductBlockSet): ProductBlockData[] => {
  const res = useProductBlockSetQuery({ variables: { id } });

  return transformProductBlockSetData(res);
};

export default useProductBlockSetData;
